import { render, staticRenderFns } from "./award-list.vue?vue&type=template&id=d916d072&scoped=true&lang=pug&"
import script from "./award-list.vue?vue&type=script&lang=js&"
export * from "./award-list.vue?vue&type=script&lang=js&"
import style0 from "./award-list.vue?vue&type=style&index=0&id=d916d072&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d916d072",
  null
  
)

export default component.exports